import { v4 as uuidV4 } from "uuid";

import { MaxKeywordLength } from "./consts";

export function generateStreamId() {
  return `web-${uuidV4()}-${Date.now()}`;
}

export function sanitizeKeyword(keyword?: string) {
  return keyword?.trim()?.slice(0, MaxKeywordLength) ?? "";
}
